/**
 * Procedure Categories and Procedures for M.Ch. in Vascular Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 4, 10-11: "Open vascular Procedures & Endovascular procedures")
 */
export const VASCULAR_SURGERY_PROCEDURES = {
  "Open Arterial Reconstruction & Aortic Aneurysm Surgery Procedures": [
    "Open Repair of Abdominal Aortic Aneurysm (AAA) & Thoraco-Abdominal Aortic Aneurysm (TAAA)",
    "Carotid Endarterectomy (CEA) & Carotid Revascularization",
    "Peripheral Bypass Grafting (Femoro-Popliteal, Aorto-Femoral, Femoro-Distal & Extra-Anatomic Bypass)",
    "Aorto-Renal & Aorto-Visceral Arterial Revascularization Bypass",
    "Surgical Repair of Peripheral Arterial Aneurysms (Popliteal / Femoral)",
    "Surgical Repair of Vascular Trauma (Arterial & Venous Injuries)",
    "Open Arterial & Venous Embolectomy & Thrombectomy",
  ],
  "Endovascular Interventions & Catheter-Directed Procedures": [
    "Percutaneous Transluminal Angioplasty (PTA) & Stenting (Iliac, Femoropopliteal & Carotid Stenting)",
    "Endovascular Aneurysm Repair (EVAR) & Thoracic Endovascular Aortic Repair (TEVAR)",
    "Catheter-Directed Thrombolysis (CDT) & Mechanical Thrombectomy for DVT & Acute Limb Ischemia",
    "Inferior Vena Cava (IVC) Filter Placement & Retrieval",
    "Percutaneous Endovascular Treatment of Arteriovenous Malformations (AVMs) & Fistulae",
  ],
  "Venous, Vascular Access, Sympathectomy & Amputation Procedures": [
    "Arteriovenous (AV) Fistula Creation & AV Graft Placement for Hemodialysis Access",
    "Endovenous Laser Ablation (EVLA), Radiofrequency Ablation (RFA) & Stripping of Varicose Veins",
    "Lumbar Sympathectomy & Thoracic Outlet Decompression",
    "Saphenous Vein Harvesting & Femoral / Aortic Cannulation",
    "Amputations of Lower & Upper Extremities (Toe, Trans-Metatarsal, BKA, AKA)",
    "Surgical Debridement & Management of Diabetic Foot Ulcers",
  ],
};

export const VASCULAR_SURGERY_CATEGORIES = Object.keys(VASCULAR_SURGERY_PROCEDURES);

export const isMChInVascularSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("vascular surgery") || d.includes("vascular");
};
